import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/Home.vue'
import Services from '@/views/Services.vue'
import UserAgreement from '@/views/UserAgreement.vue'
import PrivacyAgreement from '@/views/PrivacyAgreement.vue'
import SharePage from '@/views/SharePage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    path: '/user-agreement',
    name: 'UserAgreement',
    component: UserAgreement,
    meta: {
      hideNavbar: true
    }
  },
  {
    path: '/privacy-agreement',
    name: 'PrivacyAgreement',
    component: PrivacyAgreement,
    meta: {
      hideNavbar: true
    }
  },
  {
    path: '/share',
    name: 'Share',
    component: SharePage,
    meta: {
      hideNavbar: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
